//
//
//
//
//

export default {
    name: 'mt-layout-container-multiple',
    methods: {
        handleClick(evt) {
            this.$emit('click',evt);
        }
    },
    props: {
    }
};




// WEBPACK FOOTER //
// ./packages/layout-container-multiple/src/layout-container-multiple.vue